import React, { useEffect, useState } from "react";
import HashLoader from "react-spinners/HashLoader";
import {
  FaClipboardList,
  FaTools,
  FaChartBar,
  FaBell,
  FaClock
} from "react-icons/fa";

import styles from "./Home.module.css";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);

      const storedName = sessionStorage.getItem("userNombre");
      if (storedName) setName(storedName);
    }, 1800);
  }, []);

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Buenos días";
    if (hour < 18) return "Buenas tardes";
    return "Buenas noches";
  };

  const cards = [
    {
      title: "Registros de hoy",
    //   value: "12",
      icon: <FaClipboardList />,
      color: "#6366f1",
    },
    {
      title: "Operaciones",
    //   value: "5 activas",
      icon: <FaTools />,
      color: "#22c55e",
    },
    {
      title: "Informes",
    //   value: "3 nuevos",
      icon: <FaChartBar />,
      color: "#eab308",
    },
    {
      title: "Notificaciones",
    //   value: "7",
      icon: <FaBell />,
      color: "#ef4444",
    },
  ];

  if (loading) {
    return (
      <div className={styles.spinnerContainer}>
        <div className={styles.loaderCard}>
          <HashLoader color="#6366f1" size={70} />
          <p className={styles.loaderText}>Cargando tu espacio...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.home}>
      {/* ===== HEADER ===== */}
      <div className={styles.welcome}>
        <h2>
          {getGreeting()},{" "}
          <span className={styles.name}>{name || "Invitado"}</span>
        </h2>

        <div className={styles.date}>
          <FaClock />
          {new Date().toLocaleDateString("es-CO", {
            weekday: "long",
            day: "numeric",
            month: "long",
          })}
        </div>
      </div>

      {/* ===== CARDS ===== */}
      <div className={styles.grid}>
        {cards.map((c, i) => (
          <div
            key={i}
            className={styles.card}
            style={{ borderColor: c.color }}
          >
            <div
              className={styles.cardIcon}
              style={{ background: c.color }}
            >
              {c.icon}
            </div>

            <div>
              <p className={styles.cardTitle}>{c.title}</p>
              <h3 className={styles.cardValue}>{c.value}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* ===== ACCESOS RÁPIDOS ===== */}
      <div className={styles.quick}>
        <h4>Accesos rápidos</h4>

        <div className={styles.quickGrid}>
          <button className={styles.quickBtn}>
            <FaClipboardList /> Nuevo Registro
          </button>

          <button className={styles.quickBtn}>
            <FaTools /> Ir a Operaciones
          </button>

          <button className={styles.quickBtn}>
            <FaChartBar /> Ver Informes
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
